import React from "react";
import Breadcrumb from "../../../CommonComponents/BreadCrumb/BreadCrumb";
import { csrfToken } from "../../../../utils/csrfTokenUtils";
import { AdminModalFooter } from "../../../Admin/Shared";
import "../../../Admin/Shared/AdminFormInput.css";
import "../admin.css";

const AddBotPage = () => {
  return (
    <div className="admin-module">
      <div className="admin-bot-page admin-content">
        <Breadcrumb string="Admin / Potential Bots / Add" />
        <div className="container admin-bot-container">
          <form
            action="/admin/potential_bots"
            method="post"
            className="admin-form-page"
          >
            <input
              type="hidden"
              value={csrfToken()}
              name="authenticity_token"
            />
            <input
              type="hidden"
              value="Create Potential bot"
              name="commit"
            />
            <div className="admin-form-group">
              <label htmlFor="ip" className="admin-form-label">
                IP Address <span className="text-danger ms-1">*</span>
              </label>
              <textarea
                id="ip"
                name="potential_bot[ip_data]"
                className="admin-form-input"
                rows={4}
                placeholder="Enter IP addresses (one per line)"
                required
              />
            </div>
            <AdminModalFooter
              onCancel={() => (window.location.href = "/admin/potential_bots")}
              onSubmit={() => {}}
              cancelText="Back"
              submitText="Create Potential Bot"
              submitType="submit"
            />
          </form>
        </div>
      </div>
    </div>
  );
};
export default AddBotPage;
